import Image from "next/image";
import { Badge } from "@/components/ui/badge";

const packagingFeatures = [
  {
    title: "PROTECTIVE PACKAGING",
    description: "Each wheel is securely wrapped to prevent scratches and damage during transit.",
  },
  {
    title: "IMPACT PROTECTION",
    description: "Cardboard inserts and padding are used to protect wheel faces during handling and transport.",
  },
  {
    title: "SECURE TRANSPORT PREPARATION",
    description: "Wheels are stabilized and prepared for transport to avoid shifting during delivery.",
  },
  {
    title: "PRE-DISPATCH CHECK",
    description: "Every package is inspected before shipping to ensure it meets our safety standards.",
  },
];

export default function PackagingSection() {
  return (
    <section className="py-10 sm:py-14 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8 lg:px-20 bg-background-50">
      {/* Header */}
      <div className="text-center mb-8 sm:mb-12 md:mb-16">
        <Badge variant="outline" className="font-plus-jakarta text-xs sm:text-sm font-medium text-neutral-500 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-4 sm:mb-6 bg-white">
          packaging & handling
        </Badge>
        <h2 className="font-plus-jakarta text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-900 mb-4 sm:mb-6">
          PACKED WITH CARE,<br className="hidden sm:block" /> DELIVERED WITH CONFIDENCE
        </h2>
        <p className="font-plus-jakarta text-sm md:text-base text-neutral-300 max-w-3xl mx-auto">
          Before shipping, every wheel is securely wrapped and prepared using protective materials to prevent scratches, pressure damage, and movement during transit.
        </p>
      </div>

      {/* Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-4">
        {/* Left - Features */}
        <div className="flex flex-col gap-6 lg:gap-0 lg:justify-between lg:h-[484px]">
          {packagingFeatures.map((feature, index) => (
            <div key={index}>
              <h3 className="font-plus-jakarta text-base sm:text-lg font-bold text-neutral-900">
                {feature.title}
              </h3>
              <p className="font-plus-jakarta text-sm sm:text-base text-neutral-300 leading-relaxed max-w-[550px]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Right - Image */}
        <div className="relative rounded-xl sm:rounded-2xl overflow-hidden h-[300px] sm:h-[400px] lg:h-[484px]">
          <Image
            src="/image/shipping/rims.png"
            alt="Wrapped wheels ready for shipping"
            fill
            className="object-cover"
          />
        </div>
      </div>
    </section>
  );
}
